/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react"
import BackButton from "../../../../components/Tablet/BackButton"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import GridButton from "../../../../components/Tablet/GridButton"
import { useHistory } from "react-router-dom"
import { TenkoDetailContext } from "../../context/context"
import ZyomuinInfo from "../../../../components/Tablet/ZyomuinInfo"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBeer, faCheck, faTimes } from "@fortawesome/free-solid-svg-icons"
import { inputAlcoholNumberPage } from "../../../../constant/tablet/pages"

const SelectSyukiObi = () => {
  const history = useHistory()

  const { 点呼明細, set点呼明細 } = useContext(TenkoDetailContext)

  const select酒気帯び = (酒気帯フラグ: 0 | 1) => () => {
    set点呼明細({
      ...点呼明細,
      酒気帯フラグ: 酒気帯フラグ,
    })
    history.push(inputAlcoholNumberPage.Route.path)
  }

  return (
    <>
      <ZyomuinInfo />
      <table
        style={{ tableLayout: "fixed", height: CSS_PROPERTY.BODY_TABLE_HEIGHT }}
        className="w-100 mt-3">
        <tbody>
          <tr>
            <td colSpan={2}>アルコール測定の結果はどうでしたか？</td>
          </tr>
          <tr>
            <td>
              <GridButton onTouchStartEventHandler={select酒気帯び(0)}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <div
                    className="d-inline-block"
                    style={{ position: "relative" }}>
                    <FontAwesomeIcon
                      style={{ marginRight: "2rem" }}
                      icon={faBeer}
                    />
                    <FontAwesomeIcon
                      style={{
                        color: "#0074be",
                        fontSize: "4rem",
                        position: "absolute",
                        top: "-1rem",
                        left: "-1rem",
                      }}
                      icon={faCheck}
                    />
                  </div>
                  <span>酒気帯び</span>
                  <span style={{ fontWeight: "bold" }}>無</span>
                </div>
              </GridButton>
            </td>
            <td>
              <GridButton onTouchStartEventHandler={select酒気帯び(1)}>
                <div
                  style={{
                    width: "100%",
                    margin: "auto",
                    textAlign: "center",
                  }}>
                  <div
                    className="d-inline-block"
                    style={{ position: "relative" }}>
                    <FontAwesomeIcon
                      style={{ marginRight: "2rem" }}
                      icon={faBeer}
                    />
                    <FontAwesomeIcon
                      style={{
                        color: CSS_PROPERTY.WARN_COLOR,
                        fontSize: "4rem",
                        position: "absolute",
                        top: "-1rem",
                        left: "-1rem",
                      }}
                      icon={faTimes}
                    />
                  </div>
                  <span>酒気帯び</span>
                  <span style={{ fontWeight: "bold" }}>有</span>
                </div>
              </GridButton>
            </td>
          </tr>
          <tr>
            <td
              className="align-bottom"
              style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              <BackButton />
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default SelectSyukiObi
